import { QueryList } from '@angular/core';
import { InputFileComponent } from '../components/input-file/input-file.component';

export const EventClickInputFile = (
    inputsFile?: QueryList<InputFileComponent> | any
) => {
    for (const item of inputsFile) {
        if (!item.control.value) {
            item.inputFile.nativeElement.click();
            break;
        }
    }
};
